import { render } from "./ResetPasswordView.vue?vue&type=template&id=204a74a5&scoped=true"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js"

import "./ResetPasswordView.vue?vue&type=style&index=0&id=204a74a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204a74a5"]])

export default __exports__